var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 23,
    viewBox: "0 0 35 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8134_70526)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M32.2332 0.449097H2.7668C1.19895 0.449097 0 1.64226 0 3.20254V19.6957C0 21.2559 1.29117 22.4491 2.7668 22.4491H32.2332C33.8011 22.4491 35 21.2559 35 19.6957V3.19336C34.9908 1.63308 33.6996 0.449097 32.2332 0.449097Z",
    fill: "#010202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2343 1.36794C33.2488 1.36794 34.0788 2.19398 34.0788 3.20357V19.6967C34.0788 20.7063 33.2488 21.5323 32.2343 21.5323H2.76787C1.75338 21.5323 0.92334 20.7063 0.92334 19.6967V3.19439C0.92334 2.1848 1.75338 1.35876 2.76787 1.35876H32.2343",
    fill: "#286CB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26444 9.85859L8.97458 11.5749H7.55429L8.26444 9.85859ZM23.0668 9.93201H20.3277V10.6938H23.0207V11.8319H20.3277V12.6763H23.0668V13.3555L24.9759 11.2996L23.0668 9.15187V9.93201ZM10.1182 7.78433H13.798L14.6188 9.55571L15.3751 7.77515H24.9206L25.9166 8.86735L26.9403 7.77515H31.3211L28.0839 11.3087L31.2934 14.8148H26.8389L25.8428 13.7226L24.8099 14.8148H9.24204L8.79013 13.7226H7.74797L7.29606 14.8148H3.69922L6.72425 7.77515H9.8784L10.1182 7.78433ZM18.0958 8.77556H16.0299L14.6465 12.0154L13.1524 8.77556H11.105V13.1811L9.20515 8.77556H7.36984L5.17484 13.8235H6.60436L7.05627 12.7313H9.46338L9.91529 13.8235H12.4239V10.2165L14.0378 13.8235H15.1353L16.7401 10.2257V13.8235H18.0866L18.0958 8.77556ZM26.6913 11.3087L29.0246 8.77556H27.3461L25.8705 10.3542L24.441 8.77556H19.0181V13.8327H24.3672L25.8521 12.2357L27.2816 13.8327H29.0062L26.6913 11.3087Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8134_70526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 22,
    fill: "white",
    transform: "translate(0 0.449097)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.2dead102bfdfa7bd27f33a4fcb39af47.svg";
export { ForwardRef as ReactComponent };